/* eslint-disable import/prefer-default-export */
import { VOTE_AREA, SHOW_VOTE_AREA_MODAL, HIDE_VOTE_AREA_MODAL } from './types';

// eslint-disable-next-line camelcase
export function submitArea({ email, coordinates, post_code }) {
  return (dispatch, getState) => {
    const { request } = getState();

    return dispatch({
      type: VOTE_AREA,
      endpoint: '/orderapp/v1/coverage/requests',
      options: {
        method: 'POST',
        body: {
          tld: request.country.tld,
          email,
          coordinates,
          post_code,
        },
      },
    });
  };
}

export function showVoteAreaModal() {
  return {
    type: SHOW_VOTE_AREA_MODAL,
  };
}

export function hideVoteAreaModal() {
  return {
    type: HIDE_VOTE_AREA_MODAL,
  };
}
